module.exports = __webpack_public_path__ + "media/images/thumb_22_staff_list-81d04823.jpeg";